import axios from '../utils/axios'

const login = ({ email, password }) => {
    return new Promise((resolve, reject) => {
        axios.get('/sanctum/csrf-cookie').then(res => {
            axios.post('/login', { email, password, recaptcha: localStorage.getItem('reCaptchaToken') })
                .then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
        })
    });
}

const forgotPassword = ({ email }) => {
    return new Promise((resolve, reject) => {
        axios.get('/sanctum/csrf-cookie').then(res => {
            axios.post('/forgot-password', { email, recaptcha: localStorage.getItem('reCaptchaToken') })
                .then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
        })
    });
}

const resetPassword = ({ token, email, password, password_confirmation }) => {
    return new Promise((resolve, reject) => {
        axios.get('/sanctum/csrf-cookie').then(res => {
            axios.post('/reset-password', { token, email, password, password_confirmation, recaptcha: localStorage.getItem('reCaptchaToken') })
                .then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
        })
    });
}

const register = ({ first_name, last_name, email, password, password_confirmation }) => {
    return new Promise((resolve, reject) => {
        axios.get('/sanctum/csrf-cookie').then(res => {
            axios.post('/register', { first_name, last_name, email, password, password_confirmation, recaptcha: localStorage.getItem('reCaptchaToken') })
                .then(res => {
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
        })
    });
}

const logout = () => {
    return axios.post('/logout');
}

const user = () => {
    return axios.get('/api/user');
}

export {
    login, logout, user, register, forgotPassword, resetPassword
}
